// extracted by mini-css-extract-plugin
export default {"price":"mZ-z","onSale":"nZ-z","msrpLabelPrice":"oZ-z","msrpLabel":"pZ-z","originalPrice":"qZ-z","percentOff":"rZ-z"};